import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        input: {
            flex: 1,
            borderBouttom: 'none',
            border: '1px solid #BCBCBC',
            paddingTop: '0.75vh',
            paddingBottom: '0.75vh',
            paddingLeft: '1.5vh',
            backgroundColor: 'white',
            borderRadius: '4px',
            width: 'calc(100% - 1.5vh)',
            '&.MuiInput-underline': {
                borderBouttom: 'none'
            },
            '& input': {
                fontFamily: 'Poppins',
                fontSize: 14,
            },
            '& input::placeholder': {
                fontFamily: 'Poppins',
                fontSize: 14,
                color: '#9799B1',
            },
        },
        iconButton: {
            color: 'rgba(14, 18, 71, 1)',
            position: 'relative',
            left: 0,
            fontSize: 21,
            marginRight: 9,
        },
    })
);
